import { IAvatarConfig } from '@design-system/components/m-avatar';
import { User } from '../User';

export interface IExpertNote {
  id: string;
  noteType: ExpertNoteType;
  note: string;
  createdBy: User | null;
  modifiedBy: User | null;
  createdAt: Date;
  modifiedAt: Date;
  disabled?: boolean;
  avatarConfig?: IAvatarConfig[];
  avatarTooltip?: string;
}

export interface IExpertNoteRequest {
  noteType: ExpertNoteType;
  note: string | null;
}

export interface IRequest {
  clientId: number;
  brandId: number;
}

export enum ExpertNoteType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL'
}
